import { render, staticRenderFns } from "./depreciation.panels.vue?vue&type=template&id=347c81dd&scoped=true&"
import script from "./depreciation.panels.vue?vue&type=script&lang=js&"
export * from "./depreciation.panels.vue?vue&type=script&lang=js&"
import style0 from "./depreciation.panels.vue?vue&type=style&index=0&id=347c81dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c81dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow})
